import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { IconTrash } from '@xing-com/icons';
import { mediaTiny } from '@xing-com/layout-tokens';
import { spaceXS, spaceS } from '@xing-com/tokens';

type ImageToolbarProps = {
  onEdit?: () => void;
  onDelete: () => void;
};

const ImageToolbarComponent = styled.div`
  align-items: center;
  margin-top: 42px;
  margin-right: ${spaceS};
  display: flex;
  width: 42px;
  height: 42px;
  justify-content: space-evenly;
  padding: ${spaceXS} 6px;
  z-index: 5;

  @media ${mediaTiny} {
    height: 48px;
    width: 48px;
  }
`;

const ToolbarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  position: absolute;
  top: ${spaceS};
  width: 100%;
`;

const ImageToolbar = ({ onDelete }: ImageToolbarProps) => (
  <ToolbarWrapper data-testid="ae-cover-toolbar">
    <ImageToolbarComponent>
      <Button
        data-testid="ae-cover-toolbar-delete"
        icon={IconTrash}
        onClick={() => onDelete()}
        variant="overlay"
        size="medium"
      />
    </ImageToolbarComponent>
  </ToolbarWrapper>
);

export { ImageToolbar };
